<template>
    <div v-if="model">
        <v-dialog v-model="model" max-width="600">
            <v-card>
                <v-container>
                    <v-card-title>{{ model.id ? "Edit Customer" : "New Customer" }}</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="model.name" label="Name" />
                        <v-textarea v-model="model.address" label="Address" rows="3"></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn @click="$emit('cancel')" text :disabled="loading">Cancel</v-btn>
                        <v-btn color="primary" @click="save()" :dark="!loading" depressed :disabled="loading">{{ model.id ? "Update" : "Create" }}</v-btn>
                    </v-card-actions>
                </v-container>
                <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { api } from '@/services/api';

export default {
    props: ["model"],
    data: () => ({
        loading: false
    }),
    methods: {
        async save() {
            let req = {
                "id": this.model.id,
                "name": this.model.name,
                "address": this.model.address
            };

            this.loading = true;

            await api("/admin/customers/save", req);

            this.loading = false;

            this.$emit("close");
        }
    },
};
</script>